module.exports = __webpack_public_path__ + "static/media/arts_19.a2f0281c.jpg";